import type { DictationProvider } from './types';

/**
 * Checks if the specified dictation provider is supported in the current environment.
 * Dynamically imports the adapter module to avoid bundling unused code.
 */
export async function checkAdapterSupport(provider: DictationProvider): Promise<boolean> {
  if (provider === 'elevenlabs') {
    const { ElevenLabsScribeAdapter } = await import('./elevenlabs-scribe-adapter');
    return ElevenLabsScribeAdapter.isSupported();
  }
  const { BrowserDictationAdapterWrapper } = await import('./browser-dictation-adapter');
  return BrowserDictationAdapterWrapper.isSupported();
}
